import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import {
  useFirestoreConnect,
  isLoaded,
  useFirebase,
} from 'react-redux-firebase';
import deepCompare from 'deep-equal';
import moment from 'moment';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import LoadingData from '../../components/LoadingData';
import Header from '../../components/Header';
import Sider from '../../components/Sider';
import Filter from '../../components/Filter';
import { SingleAnnotationVerification as Annotation } from '../../components/SingleAnnotation';

import {
  annotationVerificationPhotoDocumentSaveInit,
  annotationVerificationPhotoDocumentSave,
  annotationVerificationPhotoDocumentFinishInit,
  annotationVerificationPhotoDocumentFinish,
  annotationVerificationPhotoDocumentsReserveInit,
  annotationVerificationPhotoDocumentsReserve,
  annotationVerificationPhotoDocumentsReleaseInit,
  annotationVerificationPhotoDocumentsRelease,
  annotationVerificationPhotoDocumentsSaveInit,
  annotationVerificationPhotoDocumentsSave,
} from '../../actions/AnnotationVerification/AnnotationVerificationActions';

import {
  Section,
  Wrapper,
  Content,
  Panel,
  PanelInner,
  Information,
  Text,
  Button,
  Center,
} from './AnnotationVerificationPage.style';

const AnnotationVerificationPage = () => {
  const ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_LOCALSTORAGE =
    'APP_ANNOTATION_VERIFICATION_PHOTO_DOCUMENT';
  const ANNOTATION_VERIFICATION_TIMESTAMP_LOCALSTORAGE =
    'APP_ANNOTATION_VERIFICATION_TIMESTAMP_CHANGE';
  const ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_TAGS_CHANGE_LOCALSTORAGE =
    'APP_ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_TAGS_CHANGE';
  const ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_OBJECTS_CHANGE_LOCALSTORAGE =
    'APP_ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_OBJECTS_CHANGE';
  const [defaultAnnotationPhotoDocumentsLimit] = useState(10);
  const intl = useIntl();
  const theme = useTheme();
  const dispatch = useDispatch();
  const firebase = useFirebase();
  const { profile } = useSelector((state) => state.firebase);
  const isProfileCompany = profile.company && profile.company.id ? true : false;
  const filterStore = useSelector((state) => state.filterStore);
  const [annotationTimestamp, setAnnotationTimestamp] = useState(
    JSON.parse(
      localStorage.getItem(ANNOTATION_VERIFICATION_TIMESTAMP_LOCALSTORAGE)
    ) || undefined
  );

  const photoDocuments = useSelector(
    (state) => state.firestore.ordered['photosAnnotationVerification']
  );
  const [reservedPhotoDocumentsId, setReservedPhotoDocumentsId] = useState(
    JSON.parse(
      localStorage.getItem(ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_LOCALSTORAGE)
    ) || undefined
  );

  const [selectedPhotoDocuments, setSelectedPhotoDocuments] = useState(
    undefined
  );
  const [
    selectedPhotoDocumentSelectedObject,
    setSelectedPhotoDocumentSelectedObject,
  ] = useState(undefined);

  const reservedPhotoDocuments = useSelector(
    (state) =>
      annotationTimestamp &&
      state.firestore.ordered[
        `reservedPhotosAnnotationVerification/${annotationTimestamp}`
      ]
  );

  const [
    changedPhotoTagsAnnotationVerification,
    setChangedPhotoTagsAnnotationVerification,
  ] = useState(
    JSON.parse(
      localStorage.getItem(
        ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_TAGS_CHANGE_LOCALSTORAGE
      )
    ) || undefined
  );
  const [
    changedObjectsAnnotationVerification,
    setChangedObjectsAnnotationVerification,
  ] = useState(
    JSON.parse(
      localStorage.getItem(
        ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_OBJECTS_CHANGE_LOCALSTORAGE
      )
    ) || undefined
  );

  const {
    isLoading: isLoadingReserve,
    isError: isErrorReserve,
    error: errorReserve,
  } = useSelector(
    (state) => state.annotationVerificationPhotoDocumentReserveStore
  );

  const { isLoading: isLoadingSave } = useSelector(
    (state) => state.annotationVerificationPhotoDocumentSaveStore
  );

  const { isLoading: isLoadingFinish } = useSelector(
    (state) => state.annotationVerificationPhotoDocumentFinishStore
  );

  const { isLoading: isLoadingRelease } = useSelector(
    (state) => state.annotationVerificationPhotoDocumentReleaseStore
  );

  const handleReserveAnnotationVerification = (options = {}) => {
    const { remainingReservedPhotoDocumentsId } = options;
    if (isProfileCompany) {
      const countAvailableReservePhotoDocuments =
        defaultAnnotationPhotoDocumentsLimit -
        ((remainingReservedPhotoDocumentsId &&
          remainingReservedPhotoDocumentsId.length) ||
          0);
      const photoDocumentsIds =
        photoDocuments &&
        photoDocuments
          .map((photoDocument) => photoDocument.id)
          .slice(0, countAvailableReservePhotoDocuments);
      if (photoDocumentsIds && photoDocumentsIds.length > 0) {
        dispatch(
          annotationVerificationPhotoDocumentsReserve({
            ids: photoDocumentsIds,
          })
        ).then((res) => {
          if (res) {
            if (remainingReservedPhotoDocumentsId) {
              setReservedPhotoDocumentsId([
                ...remainingReservedPhotoDocumentsId,
                ...photoDocumentsIds,
              ]);
            } else setReservedPhotoDocumentsId([...photoDocumentsIds]);
            // setSelectedPhotoDocuments(undefined);
            // setSelectedPhotoDocumentSelectedObject(undefined);
            // setChangedPhotoTagsAnnotationVerification(
            //   remainingReservedPhotoDocumentsId &&
            //     remainingReservedPhotoDocumentsId.length > 0
            //     ? Object.assign({}, changedPhotoTagsAnnotationVerification)
            //     : undefined
            // );
            // setChangedObjectsAnnotationVerification(
            //   remainingReservedPhotoDocumentsId &&
            //     remainingReservedPhotoDocumentsId.length > 0
            //     ? Object.assign({}, changedObjectsAnnotationVerification)
            //     : undefined
            // );
          }
          dispatch(annotationVerificationPhotoDocumentsReserveInit());
        });
      }
    }
  };

  const handleSaveAnnotationVerification = (options = {}) => {
    const { isRejected = false, sequenceSave = false } = options;
    if (isProfileCompany) {
      if (sequenceSave) {
        const data = [];
        if (reservedPhotoDocuments && reservedPhotoDocuments.length > 0) {
          reservedPhotoDocuments.forEach(({ id, ...photoDocument }) => {
            const photoTagsManualAnnotation =
              (photoDocument.vinne_annotation &&
                photoDocument.vinne_annotation.photo &&
                photoDocument.vinne_annotation.photo.tags) ||
              [];
            const currentPhotoTagsManualAnnotation = isRejected
              ? photoTagsManualAnnotation
              : (changedPhotoTagsAnnotationVerification &&
                  changedPhotoTagsAnnotationVerification[id] &&
                  Object.entries(
                    changedPhotoTagsAnnotationVerification[id]
                  ).map(([category, value]) => `${category}.${value}`)) ||
                [];

            const isChangedPhotoTagsAnnotation = deepCompare(
              photoTagsManualAnnotation,
              currentPhotoTagsManualAnnotation
            )
              ? false
              : true;

            const objectsManualAnnotation =
              (photoDocument.vinne_annotation &&
                photoDocument.vinne_annotation.objects &&
                photoDocument.vinne_annotation.objects.data) ||
              [];
            const currentObjectsManualAnnotation = isRejected
              ? objectsManualAnnotation
              : (changedObjectsAnnotationVerification &&
                  changedObjectsAnnotationVerification[id] &&
                  changedObjectsAnnotationVerification[id].map((object) => ({
                    ...object,
                    tags:
                      (object.tags &&
                        Object.entries(object.tags).map(
                          ([category, value]) => `${category}.${value}`
                        )) ||
                      [],
                  }))) ||
                [];

            const isChangedObjectsAnnotation = deepCompare(
              objectsManualAnnotation,
              currentObjectsManualAnnotation
            )
              ? false
              : true;

            data.push({
              id,
              photoTags: currentPhotoTagsManualAnnotation,
              isChangedPhotoTags: isChangedPhotoTagsAnnotation,
              objects: currentObjectsManualAnnotation,
              isChangedObjects: isChangedObjectsAnnotation,
            });
          });

          dispatch(
            annotationVerificationPhotoDocumentsSave({
              data,
              isRejected,
            })
          ).then((res) => {
            const remainingReservedPhotoDocumentsId = reservedPhotoDocumentsId.filter(
              (reservedPhotoDocumentId) =>
                !(
                  data &&
                  data.find(
                    (photoDocument) =>
                      photoDocument.id === reservedPhotoDocumentId
                  )
                )
            );
            if (res) {
              setReservedPhotoDocumentsId(
                remainingReservedPhotoDocumentsId &&
                  remainingReservedPhotoDocumentsId.length > 0
                  ? remainingReservedPhotoDocumentsId
                  : undefined
              );
              setSelectedPhotoDocuments(undefined);
              setSelectedPhotoDocumentSelectedObject(undefined);
              setChangedPhotoTagsAnnotationVerification(
                remainingReservedPhotoDocumentsId &&
                  remainingReservedPhotoDocumentsId.length > 0
                  ? Object.fromEntries(
                      Object.entries(
                        Object.assign(
                          {},
                          changedPhotoTagsAnnotationVerification
                        )
                      ).filter(([id]) =>
                        remainingReservedPhotoDocumentsId.includes(id)
                      )
                    )
                  : undefined
              );
              setChangedObjectsAnnotationVerification(
                remainingReservedPhotoDocumentsId &&
                  remainingReservedPhotoDocumentsId.length > 0
                  ? Object.fromEntries(
                      Object.entries(
                        Object.assign({}, changedObjectsAnnotationVerification)
                      ).filter(([id]) =>
                        remainingReservedPhotoDocumentsId.includes(id)
                      )
                    )
                  : undefined
              );
            }
            dispatch(annotationVerificationPhotoDocumentsSaveInit());
            if (res)
              if (photoDocuments && photoDocuments.length > 0)
                handleReserveAnnotationVerification({
                  remainingReservedPhotoDocumentsId,
                });
          });
        }
      } else {
        if (selectedPhotoDocuments && selectedPhotoDocuments.length > 0) {
          const { id, ...photoDocument } = selectedPhotoDocuments[0];
          const photoTagsManualAnnotation =
            (photoDocument.vinne_annotation &&
              photoDocument.vinne_annotation.photo &&
              photoDocument.vinne_annotation.photo.tags) ||
            [];
          const currentPhotoTagsManualAnnotation = isRejected
            ? photoTagsManualAnnotation
            : (changedPhotoTagsAnnotationVerification &&
                changedPhotoTagsAnnotationVerification[id] &&
                Object.entries(changedPhotoTagsAnnotationVerification[id]).map(
                  ([category, value]) => `${category}.${value}`
                )) ||
              [];

          const isChangedPhotoTagsAnnotation = deepCompare(
            photoTagsManualAnnotation,
            currentPhotoTagsManualAnnotation
          )
            ? false
            : true;

          const objectsManualAnnotation =
            (photoDocument.vinne_annotation &&
              photoDocument.vinne_annotation.objects &&
              photoDocument.vinne_annotation.objects.data) ||
            [];
          const currentObjectsManualAnnotation = isRejected
            ? objectsManualAnnotation
            : (changedObjectsAnnotationVerification &&
                changedObjectsAnnotationVerification[id] &&
                changedObjectsAnnotationVerification[id].map((object) => ({
                  ...object,
                  tags:
                    (object.tags &&
                      Object.entries(object.tags).map(
                        ([category, value]) => `${category}.${value}`
                      )) ||
                    [],
                }))) ||
              [];

          const isChangedObjectsAnnotation = deepCompare(
            objectsManualAnnotation,
            currentObjectsManualAnnotation
          )
            ? false
            : true;

          dispatch(
            annotationVerificationPhotoDocumentSave({
              id,
              photoTags: currentPhotoTagsManualAnnotation,
              isChangedPhotoTags: isChangedPhotoTagsAnnotation,
              objects: currentObjectsManualAnnotation,
              isChangedObjects: isChangedObjectsAnnotation,
              isRejected,
            })
          ).then((res) => {
            const remainingReservedPhotoDocumentsId = reservedPhotoDocumentsId.filter(
              (reservedPhotoDocumentId) => reservedPhotoDocumentId !== id
            );
            if (res) {
              setReservedPhotoDocumentsId(
                remainingReservedPhotoDocumentsId &&
                  remainingReservedPhotoDocumentsId.length > 0
                  ? remainingReservedPhotoDocumentsId
                  : undefined
              );
              setSelectedPhotoDocuments(undefined);
              setSelectedPhotoDocumentSelectedObject(undefined);
              setChangedPhotoTagsAnnotationVerification(
                remainingReservedPhotoDocumentsId &&
                  remainingReservedPhotoDocumentsId.length > 0
                  ? Object.fromEntries(
                      Object.entries(
                        Object.assign(
                          {},
                          changedPhotoTagsAnnotationVerification
                        )
                      ).filter(([id]) =>
                        remainingReservedPhotoDocumentsId.includes(id)
                      )
                    )
                  : undefined
              );
              setChangedObjectsAnnotationVerification(
                remainingReservedPhotoDocumentsId &&
                  remainingReservedPhotoDocumentsId.length > 0
                  ? Object.fromEntries(
                      Object.entries(
                        Object.assign({}, changedObjectsAnnotationVerification)
                      ).filter(([id]) =>
                        remainingReservedPhotoDocumentsId.includes(id)
                      )
                    )
                  : undefined
              );
            }
            dispatch(annotationVerificationPhotoDocumentSaveInit());
            if (res)
              if (photoDocuments && photoDocuments.length > 0)
                handleReserveAnnotationVerification({
                  remainingReservedPhotoDocumentsId,
                });
          });
        }
      }
    }
  };

  const handleFinishAnnotationVerification = () => {
    if (isProfileCompany) {
      const remainingReservedPhotoDocumentsId = reservedPhotoDocumentsId.filter(
        (id) =>
          !(
            selectedPhotoDocuments &&
            selectedPhotoDocuments.find(
              (selectedPhotoDocument) => selectedPhotoDocument.id === id
            )
          )
      );
      if (selectedPhotoDocuments && selectedPhotoDocuments.length > 0) {
        const { id, ...photoDocument } = selectedPhotoDocuments[0];
        const photoTagsManualAnnotation =
          (photoDocument.vinne_annotation &&
            photoDocument.vinne_annotation.photo &&
            photoDocument.vinne_annotation.photo.tags) ||
          [];
        const currentPhotoTagsManualAnnotation =
          (changedPhotoTagsAnnotationVerification &&
            changedPhotoTagsAnnotationVerification[id] &&
            Object.entries(changedPhotoTagsAnnotationVerification[id]).map(
              ([category, value]) => `${category}.${value}`
            )) ||
          [];
        const isChangedPhotoTagsAnnotation = deepCompare(
          photoTagsManualAnnotation,
          currentPhotoTagsManualAnnotation
        )
          ? false
          : true;

        const objectsManualAnnotation =
          (photoDocument.vinne_annotation &&
            photoDocument.vinne_annotation.objects &&
            photoDocument.vinne_annotation.objects.data) ||
          [];
        const currentObjectsManualAnnotation =
          (changedObjectsAnnotationVerification &&
            changedObjectsAnnotationVerification[id] &&
            changedObjectsAnnotationVerification[id].map((object) => ({
              ...object,
              tags:
                (object.tags &&
                  Object.entries(object.tags).map(
                    ([category, value]) => `${category}.${value}`
                  )) ||
                [],
            }))) ||
          [];
        const isChangedObjectsAnnotation = deepCompare(
          objectsManualAnnotation,
          currentObjectsManualAnnotation
        )
          ? false
          : true;

        dispatch(
          annotationVerificationPhotoDocumentFinish({
            id,
            photoTags: currentPhotoTagsManualAnnotation,
            isChangedPhotoTags: isChangedPhotoTagsAnnotation,
            objects: currentObjectsManualAnnotation,
            isChangedObjects: isChangedObjectsAnnotation,
          })
        ).then((res) => {
          if (res) {
            dispatch(
              annotationVerificationPhotoDocumentsRelease({
                ids: remainingReservedPhotoDocumentsId,
              })
            ).then((res) => {
              if (res) {
                setReservedPhotoDocumentsId(undefined);
                setSelectedPhotoDocuments(undefined);
                setSelectedPhotoDocumentSelectedObject(undefined);
                setChangedPhotoTagsAnnotationVerification(undefined);
                setChangedObjectsAnnotationVerification(undefined);
              }
              dispatch(annotationVerificationPhotoDocumentsReleaseInit());
            });
          }
          dispatch(annotationVerificationPhotoDocumentFinishInit());
        });
      }
    }
  };

  const handleReleaseAnnotationVerification = () => {
    if (isProfileCompany) {
      const reservedPhotoDocumentsId = JSON.parse(
        localStorage.getItem(
          ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_LOCALSTORAGE
        )
      );
      if (reservedPhotoDocumentsId && reservedPhotoDocumentsId.length > 0) {
        handleClearReservedPhotoDocumentAnnotationVerificationLocalStorage();
        handleClearTimestampAnnotationVerificationLocalStorage();
        handleClearPhotoTagsAnnotationVerificationLocalStorage();
        handleClearObjectsAnnotationVerificationLocalStorage();
        dispatch(
          annotationVerificationPhotoDocumentsRelease({
            ids: reservedPhotoDocumentsId,
          })
        ).then(() => {
          dispatch(annotationVerificationPhotoDocumentsReleaseInit());
        });
      }
    }
  };

  const handleClearReservedPhotoDocumentAnnotationVerificationLocalStorage = () =>
    localStorage.removeItem(
      ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_LOCALSTORAGE
    );
  const handleClearPhotoTagsAnnotationVerificationLocalStorage = () =>
    localStorage.removeItem(
      ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_TAGS_CHANGE_LOCALSTORAGE
    );

  const handleClearTimestampAnnotationVerificationLocalStorage = () => {
    localStorage.removeItem(ANNOTATION_VERIFICATION_TIMESTAMP_LOCALSTORAGE);
  };

  const handleClearObjectsAnnotationVerificationLocalStorage = () =>
    localStorage.removeItem(
      ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_OBJECTS_CHANGE_LOCALSTORAGE
    );

  const handleFilterAnnotationVerification = (type, data) => {
    const currentAnnotations = reservedPhotoDocuments.filter((photoDocument) =>
      reservedPhotoDocumentsId.includes(photoDocument.id)
    );
    if (currentAnnotations && currentAnnotations.length > 0) {
      const currentAnnotation =
        selectedPhotoDocuments && selectedPhotoDocuments.length > 0
          ? currentAnnotations.find(
              (photoDocument) =>
                String(photoDocument.id) ===
                String(selectedPhotoDocuments[0].id)
            )
          : currentAnnotations[0];
      if (currentAnnotation) {
        const { id } = currentAnnotation;
        if (type === 'PHOTO') {
          if (changedPhotoTagsAnnotationVerification) {
            if (changedPhotoTagsAnnotationVerification[id])
              setChangedPhotoTagsAnnotationVerification({
                ...changedPhotoTagsAnnotationVerification,
                [id]: {
                  ...changedPhotoTagsAnnotationVerification[id],
                  ...data,
                },
              });
            else
              setChangedPhotoTagsAnnotationVerification({
                ...changedPhotoTagsAnnotationVerification,
                [id]: { ...data },
              });
          } else
            setChangedPhotoTagsAnnotationVerification({
              [id]: { ...data },
            });
        } else if (type === 'OBJECT') {
          if (changedObjectsAnnotationVerification) {
            if (changedObjectsAnnotationVerification[id])
              setChangedObjectsAnnotationVerification({
                ...changedObjectsAnnotationVerification,
                [id]: [
                  ...changedObjectsAnnotationVerification[id],
                  ...data.filter(
                    (object) =>
                      !changedObjectsAnnotationVerification[id].find(
                        (arrayObject) => arrayObject.id === object.id
                      )
                  ),
                ],
              });
            else
              setChangedObjectsAnnotationVerification({
                ...changedObjectsAnnotationVerification,
                [id]: [...data],
              });
          } else setChangedObjectsAnnotationVerification({ [id]: [...data] });
        }
      }
    }
  };

  const handleChangeAnnotationVerification = (
    type,
    { categoryId, tag, startX, startY, endX, endY }
  ) => {
    const currentAnnotations = reservedPhotoDocuments.filter((photoDocument) =>
      reservedPhotoDocumentsId.includes(photoDocument.id)
    );
    if (currentAnnotations && currentAnnotations.length > 0) {
      const currentAnnotation =
        selectedPhotoDocuments && selectedPhotoDocuments.length > 0
          ? currentAnnotations.find(
              (photoDocument) =>
                String(photoDocument.id) ===
                String(selectedPhotoDocuments[0].id)
            )
          : currentAnnotations[0];
      if (currentAnnotation) {
        const { id } = currentAnnotation;
        if (type === 'PHOTO' && categoryId && tag) {
          if (changedPhotoTagsAnnotationVerification) {
            if (changedPhotoTagsAnnotationVerification[id]) {
              if (
                changedPhotoTagsAnnotationVerification[id][categoryId] === tag
              ) {
                const newChangedPhotoTagsAnnotationVerification = {
                  ...changedPhotoTagsAnnotationVerification,
                };
                delete newChangedPhotoTagsAnnotationVerification[id][
                  categoryId
                ];

                setChangedPhotoTagsAnnotationVerification({
                  ...newChangedPhotoTagsAnnotationVerification,
                });
              } else
                setChangedPhotoTagsAnnotationVerification({
                  ...changedPhotoTagsAnnotationVerification,
                  [id]: {
                    ...changedPhotoTagsAnnotationVerification[id],
                    [categoryId]: tag,
                  },
                });
            } else
              setChangedPhotoTagsAnnotationVerification({
                ...changedPhotoTagsAnnotationVerification,
                [id]: {
                  [categoryId]: tag,
                },
              });
          } else
            setChangedPhotoTagsAnnotationVerification({
              [id]: { [categoryId]: tag },
            });
        } else if (type === 'OBJECT') {
          if (selectedPhotoDocumentSelectedObject !== undefined) {
            const object =
              changedObjectsAnnotationVerification &&
              changedObjectsAnnotationVerification[id] &&
              changedObjectsAnnotationVerification[id].find(
                (object) => object.id === selectedPhotoDocumentSelectedObject
              );
            if (object) {
              const newObject = Object.assign({}, object);
              const newObjectTags = Object.assign({}, newObject.tags);

              if (
                newObjectTags[categoryId] &&
                newObjectTags[categoryId] === tag
              )
                delete newObjectTags[categoryId];
              else newObjectTags[categoryId] = tag;

              setChangedObjectsAnnotationVerification({
                ...changedObjectsAnnotationVerification,
                [id]: changedObjectsAnnotationVerification[id].map((object) =>
                  object.id === newObject.id
                    ? { ...newObject, tags: newObjectTags }
                    : object
                ),
              });
            }
          }
        } else if (type === 'OBJECT_CHANGE') {
          if (selectedPhotoDocumentSelectedObject !== undefined) {
            const object =
              changedObjectsAnnotationVerification &&
              changedObjectsAnnotationVerification[id] &&
              changedObjectsAnnotationVerification[id].find(
                (object) => object.id === selectedPhotoDocumentSelectedObject
              );
            if (object) {
              const newObject = Object.assign({}, object);
              newObject.coordinates = [
                { x: startX, y: startY },
                { x: endX, y: endY },
              ];
              setChangedObjectsAnnotationVerification({
                ...changedObjectsAnnotationVerification,
                [id]: changedObjectsAnnotationVerification[id].map((object) =>
                  object.id === newObject.id ? newObject : object
                ),
              });
            }
          }
        } else if (type === 'OBJECT_CREATE') {
          if (selectedPhotoDocumentSelectedObject === undefined) {
            const objectId =
              (changedObjectsAnnotationVerification &&
                changedObjectsAnnotationVerification[id] &&
                changedObjectsAnnotationVerification[id].length) ||
              0;
            if (changedObjectsAnnotationVerification)
              if (changedObjectsAnnotationVerification[id])
                setChangedObjectsAnnotationVerification({
                  ...changedObjectsAnnotationVerification,
                  [id]: [
                    ...changedObjectsAnnotationVerification[id],
                    {
                      id: objectId,
                      coordinates: [
                        { x: startX, y: startY },
                        { x: endX, y: endY },
                      ],
                      tags: [],
                    },
                  ],
                });
              else
                setChangedObjectsAnnotationVerification({
                  ...changedObjectsAnnotationVerification,
                  [id]: [
                    {
                      id: objectId,
                      coordinates: [
                        { x: startX, y: startY },
                        { x: endX, y: endY },
                      ],
                      tags: [],
                    },
                  ],
                });
            else
              setChangedObjectsAnnotationVerification({
                [id]: [
                  {
                    id: objectId,
                    coordinates: [
                      { x: startX, y: startY },
                      { x: endX, y: endY },
                    ],
                    tags: [],
                  },
                ],
              });
          }
        } else if (type === 'OBJECT_DELETE') {
          if (selectedPhotoDocumentSelectedObject !== undefined) {
            setChangedObjectsAnnotationVerification({
              ...changedObjectsAnnotationVerification,
              [id]: [
                ...changedObjectsAnnotationVerification[id]
                  .filter(
                    (object) =>
                      object.id !== selectedPhotoDocumentSelectedObject
                  )
                  .map((object, index) => ({ ...object, id: index })),
              ],
            });
            setSelectedPhotoDocumentSelectedObject(undefined);
          }
        }
      }
    }
  };

  const firestoreConnect = [];
  if (isProfileCompany) {
    const dataSourceTags =
      filterStore.dataSource !== undefined && filterStore.tags !== undefined
        ? (() => {
            const tags = Object.entries(filterStore.tags).reduce(
              (currentState, [category, tags]) => {
                if (tags) {
                  return [
                    ...currentState,
                    ...tags.split(',').map((tag) => `${category}.${tag}`),
                  ];
                }
                return currentState;
              },
              []
            );

            if (tags && tags.length > 0)
              return [
                `${filterStore.recognition || 'vinne_annotation'}.photo.tags`,
                'array-contains-any',
                tags.slice(0, 10),
              ];
            return undefined;
          })()
        : undefined;

    firestoreConnect.push({
      collection: 'companies',
      doc: profile.company.id,
      subcollections: [
        {
          collection: 'photos',
          orderBy: [['creation_date', 'asc']],
          where: [
            ['vinne_annotation.annotated', '==', true],
            ['vinne_verification.verified', '==', false],
            ['reserved', '==', false],
            ['rejected', '==', false],
            filterStore.origin !== undefined && [
              'origin_id',
              '==',
              filterStore.origin,
            ],
            filterStore.startDate !== undefined && [
              'creation_date',
              '>=',
              filterStore.startDate,
            ],
            filterStore.endDate !== undefined && [
              'creation_date',
              '<=',
              filterStore.endDate,
            ],
            filterStore.dataSource !== undefined && [
              'data_source_id',
              '==',
              filterStore.dataSource,
            ],
            dataSourceTags,
          ].filter((criteria) => criteria),
          limit: defaultAnnotationPhotoDocumentsLimit,
        },
      ],
      storeAs: `photosAnnotationVerification`,
    });
    if (
      annotationTimestamp &&
      reservedPhotoDocumentsId &&
      reservedPhotoDocumentsId.length > 0
    ) {
      firestoreConnect.push({
        collection: 'companies',
        doc: profile.company.id,
        subcollections: [
          {
            collection: 'photos',
            where: [
              firebase.firestore.FieldPath.documentId(),
              'in',
              reservedPhotoDocumentsId.slice(0, 10),
            ],
          },
        ],
        storeAs: `reservedPhotosAnnotationVerification/${annotationTimestamp}`,
      });
    }
  }
  useFirestoreConnect(firestoreConnect);

  useEffect(() => {
    return () => handleReleaseAnnotationVerification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (reservedPhotoDocumentsId)
      localStorage.setItem(
        ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_LOCALSTORAGE,
        JSON.stringify(reservedPhotoDocumentsId)
      );
    else handleClearReservedPhotoDocumentAnnotationVerificationLocalStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservedPhotoDocumentsId]);

  useEffect(() => {
    if (annotationTimestamp)
      localStorage.setItem(
        ANNOTATION_VERIFICATION_TIMESTAMP_LOCALSTORAGE,
        JSON.stringify(annotationTimestamp)
      );
    else handleClearTimestampAnnotationVerificationLocalStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [annotationTimestamp]);

  useEffect(() => {
    if (changedPhotoTagsAnnotationVerification)
      localStorage.setItem(
        ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_TAGS_CHANGE_LOCALSTORAGE,
        JSON.stringify(changedPhotoTagsAnnotationVerification)
      );
    else handleClearPhotoTagsAnnotationVerificationLocalStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changedPhotoTagsAnnotationVerification]);

  useEffect(() => {
    if (changedObjectsAnnotationVerification)
      localStorage.setItem(
        ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_OBJECTS_CHANGE_LOCALSTORAGE,
        JSON.stringify(changedObjectsAnnotationVerification)
      );
    else handleClearObjectsAnnotationVerificationLocalStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changedObjectsAnnotationVerification]);

  useEffect(() => {
    if (
      isLoaded(reservedPhotoDocuments) &&
      reservedPhotoDocuments &&
      selectedPhotoDocuments
    ) {
      setSelectedPhotoDocuments(
        selectedPhotoDocuments.filter((selectedPhotoDocument) =>
          reservedPhotoDocuments.find(
            (reservedPhotoDocument) =>
              reservedPhotoDocument.id === selectedPhotoDocument.id &&
              !reservedPhotoDocument.rejected
          )
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservedPhotoDocuments]);

  useEffect(() => {
    if (
      isLoaded(reservedPhotoDocuments) &&
      reservedPhotoDocuments &&
      reservedPhotoDocumentsId
    ) {
      setReservedPhotoDocumentsId(
        reservedPhotoDocumentsId.filter((id) =>
          reservedPhotoDocuments.find(
            (reservedPhotoDocument) =>
              reservedPhotoDocument.id === id && !reservedPhotoDocument.rejected
          )
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservedPhotoDocuments]);

  const renderInformation = (information, children) => {
    return (
      <Center>
        <Information theme={theme.content.information.default}>
          <Text>{information}</Text>
          {children ? children : ''}
        </Information>
      </Center>
    );
  };

  const renderAnnotation = () => {
    const currentAnnotations = reservedPhotoDocuments.filter((photoDocument) =>
      reservedPhotoDocumentsId.includes(photoDocument.id)
    );

    if (currentAnnotations && currentAnnotations.length > 0) {
      const currentAnnotation =
        selectedPhotoDocuments && selectedPhotoDocuments.length > 0
          ? currentAnnotations.find(
              (photoDocument) =>
                String(photoDocument.id) ===
                String(selectedPhotoDocuments[0].id)
            )
          : currentAnnotations[0];
      if (currentAnnotation) {
        return (
          <Annotation
            data={currentAnnotation}
            handleSaveAnnotation={(options = {}) =>
              handleSaveAnnotationVerification(options)
            }
            handleFinishAnnotation={() => handleFinishAnnotationVerification()}
            handleFilterAnnotation={(type, tags) =>
              handleFilterAnnotationVerification(type, tags)
            }
            changedPhotoTagsAnnotation={
              changedPhotoTagsAnnotationVerification &&
              changedPhotoTagsAnnotationVerification[currentAnnotation.id]
            }
            handleChangeAnnotation={(type, data) =>
              handleChangeAnnotationVerification(type, data)
            }
            changedObjectsAnnotation={
              changedObjectsAnnotationVerification &&
              changedObjectsAnnotationVerification[currentAnnotation.id]
            }
            handleSelectPhotoDocuments={(data) => {
              setSelectedPhotoDocuments(data);
              setSelectedPhotoDocumentSelectedObject(undefined);
            }}
            selectedObject={selectedPhotoDocumentSelectedObject}
            handleSelectObject={(id) =>
              setSelectedPhotoDocumentSelectedObject(id)
            }
            isLoading={
              isLoadingReserve ||
              isLoadingSave ||
              isLoadingFinish ||
              isLoadingRelease
            }
            isSequence={true}
            sequence={currentAnnotations}
          />
        );
      }
    }
    return <LoadingData fullmode={true} />;
  };

  return (
    <>
      <Helmet
        title={intl.formatMessage({ id: 'PAGE_TITLE.ANNOTATION_VERIFICATION' })}
      />
      <Section>
        <Sider />
        <Wrapper>
          <Header
            title={intl.formatMessage({
              id: 'PAGE_TITLE.ANNOTATION_VERIFICATION',
            })}
          />
          <Content>
            <Panel theme={theme.content.panel.default}>
              <PanelInner>
                {!isProfileCompany ? (
                  renderInformation(
                    intl.formatMessage({
                      id: `ANNOTATION_VERIFICATION.YOU_HAVE_NO_ASSIGNED_COMPANY`,
                    })
                  )
                ) : isLoaded(photoDocuments) ? (
                  reservedPhotoDocumentsId &&
                  reservedPhotoDocumentsId.length > 0 &&
                  isLoaded(reservedPhotoDocuments) &&
                  reservedPhotoDocuments &&
                  reservedPhotoDocuments.length > 0 ? (
                    renderAnnotation()
                  ) : (reservedPhotoDocumentsId &&
                      reservedPhotoDocumentsId.length > 0 &&
                      !isLoaded(reservedPhotoDocuments)) ||
                    isLoadingReserve ||
                    isLoadingSave ||
                    isLoadingFinish ||
                    isLoadingRelease ? (
                    <LoadingData fullmode={true} />
                  ) : !(photoDocuments && photoDocuments.length > 0) ? (
                    renderInformation(
                      intl.formatMessage({
                        id: `ANNOTATION_VERIFICATION.YOU_HAVE_NO_PHOTO_DOCUMENTS`,
                      })
                    )
                  ) : (
                    renderInformation(
                      isErrorReserve
                        ? errorReserve
                        : intl.formatMessage({
                            id: `ANNOTATION_VERIFICATION.YOU_CAN_EXPAND_MENU_WITH_FILTERS_ON_THE_RIGHT_OR_START_VERIFICATION_BY_CLICKING_THE_START_BUTTON`,
                          }),
                      <Button
                        theme={theme.button.default}
                        onClick={() => {
                          setAnnotationTimestamp(moment().unix());
                          handleReserveAnnotationVerification();
                        }}
                        disabled={isLoadingReserve}
                      >
                        {isLoadingReserve
                          ? intl.formatMessage({
                              id: `ANNOTATION_VERIFICATION.PLEASE_WAIT`,
                            })
                          : intl.formatMessage({
                              id: `ANNOTATION_VERIFICATION.START`,
                            })}
                      </Button>
                    )
                  )
                ) : (
                  <LoadingData fullmode={true} />
                )}
              </PanelInner>
            </Panel>
          </Content>
        </Wrapper>
        {isProfileCompany && <Filter availableFilterMultilabeling={false} />}
      </Section>
    </>
  );
};

export default AnnotationVerificationPage;
